import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { isD2RAdminEmail } from '../../constants/d2rAdminEmails';

const MobileHeader = ({ user }) => {
  const userType = (user?.userType || user?.role || "").toString().toLowerCase();
  const isStudent = userType === 'student';
  const canCreateProjects = userType === 'employer';
  const [menuOpen, setMenuOpen] = useState(false);
  const firstName = user?.name?.split(' ')[0] || 'You';
  const email = (user?.Email || user?.email || user?.preferred_username || '').toString().trim().toLowerCase();
  const isAdmin = isD2RAdminEmail(email);
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : 'auto';
  }, [menuOpen]);

  return (
    <header className="mobile-header site-header--alt show-for-small-only" id="mobile-navbar">
      <div className="site-header__back site-header__back--department">
        <a href="https://www.tamu.edu/" className="site-header__parent-link">
          <svg><use href="#aux_arrow-up-right" /></svg> Texas A&M University
        </a>{" | "}
        <a href="#" className="site-header__department-link">College Name</a>
      </div>

      <div className="mobile-header__identity">
        <div className="identity">
          <a href="/">
            <div className="identity__logo">
              <img src="https://aux.tamu.edu/logos/boxTAM.svg" alt="Texas A&M University logo" />
            </div>
            <div className="identity__wordmark">
              <span className="wordmark__small">Texas A&M University</span>
              <span className="wordmark__large">Lorem Ipsum Dolor</span>
            </div>
          </a>
        </div>
      </div>

      <div className="mobile-toggle">
        <button
          className="mobile-toggle__menu mobile-nav__menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          Menu
          <div className="menu__icon"><span /></div>
        </button>
      </div>

      {menuOpen && (
        <div className="nav-overlay">
          <div className="mobile-nav">
            <div className="mobile-nav__top">
              <button className="close" onClick={() => setMenuOpen(false)}>Close</button>
            </div>

            <div className="mobile-nav__primary">
              <Link to="/dashboard" className="mobile-nav__item" onClick={() => setMenuOpen(false)}>Dashboard</Link>
              <Link to="/projects" className="mobile-nav__item" onClick={() => setMenuOpen(false)}>Projects</Link>
              {isStudent && (
                <Link to="/profile" className="mobile-nav__item" onClick={() => setMenuOpen(false)}>Profile</Link>
              )}
              {canCreateProjects && (
                <Link to="/project-form" className="mobile-nav__item" onClick={() => setMenuOpen(false)}>Add New Project</Link>
              )}
              {isAdmin && (
                <Link to="/admin/project-proposals" className="mobile-nav__item" onClick={() => setMenuOpen(false)}>
                  Admin
                </Link>
              )}
            </div>

            {isStudent && (
              <div className="mobile-nav__persona">
                <svg className="user"><use href="#aux_user" /></svg>
                <button className="persona__button">For {firstName}</button>
              </div>
            )}

            <div className="mobile-nav__panel">
              <div className="mobile-nav__content">
                <div className="panel__links">
                  {canCreateProjects ? (
                    <>
                      <div className="panel__link-item">
                        <a href="#" className="link--cta" onClick={(e) => { e.preventDefault(); handleLogout(); }}>Logout</a>
                      </div>
                    </>
                  ) : (
                    <>
                      {isStudent && (
                        <div className="panel__link-item">
                          <Link to="/dashboard" className="link--cta" onClick={() => setMenuOpen(false)}>My Dashboard</Link>
                        </div>
                      )}
                      <div className="panel__link-item">
                        <a href="#" className="link--cta" onClick={(e) => { e.preventDefault(); handleLogout(); }}>Logout</a>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      )}
    </header>
  );
};

export default MobileHeader;
